import axios from 'axios';
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 设置公共请求头

const init = function () {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  Vue.use(ElementUI);
  const  vue=new Vue();
  function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return "";
    }
  }



  // 下面的参数有Authorization
  axios.defaults.headers.common['Authorization'] = "Basic " + getCookie("LoggerToken");


  // https request 拦截器);
  axios.interceptors.request.use(
    (config) => {
      config.cancelToken = source.token;
      return config;
    },
    (err) => {
      const error = err;
      return Promise.reject(error);
    },
  );




}

export default {
  init
}



// WEBPACK FOOTER //
// ./src/common/request.js